import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading, false = anon, object = user
  const [token, setToken] = useState(localStorage.getItem("vp_token") || null);

  const checkAuth = useCallback(async () => {
    if (window.location.hash?.includes("session_id=")) { return; }
    const t = localStorage.getItem("vp_token");
    if (!t) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("vp_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { checkAuth(); }, [checkAuth]);

  const persist = (tok, usr) => {
    localStorage.setItem("vp_token", tok);
    setToken(tok);
    setUser(usr);
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      persist(data.token, data.user);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: apiError(e) };
    }
  };

  const exchangeGoogle = async (sessionId) => {
    const { data } = await api.post("/auth/session", { session_id: sessionId });
    persist(data.token, data.user);
    return data.user;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("vp_token");
    setToken(null);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, token, login, logout, exchangeGoogle, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
